






















































































































import Vue from 'vue';
import VueQr from 'vue-qr';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import {
  mdbInput,
  mdbBtn,
  mdbContainer,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbCollapse,
} from 'mdbvue';

@Component({
  name: 'Input',
  components: {
    mdbInput,
    mdbIcon,
    mdbBtn,
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbCollapse,
    VueQr,
  },
})

export default class Input extends Vue {
  ssid: string = '';

  isSSIDHidden: boolean = false;

  password: string = '';

  noPassword: boolean = false;

  encryptionType: string = 'WPA';

  qrCode: string = '';

  qrCodeSize: string[] = ['small', 'medium', 'large'];

  qrCodeSizeSelected: string = 'small';

  logoURL: string = '';

  showLogoValidation: boolean = false;

  bgColor: string = 'rgb(67,160,71)';

  showModal: boolean = false;

  // eslint-disable-next-line max-len
  buildQRString(): string {
    // as in https://github.com/zxing/zxing/wiki/Barcode-Contents#wi-fi-network-config-android-ios-11
    return `WIFI:S:${Input.escapeSpecialChars(this.ssid)};T:${this.encryptionType};P:${Input.escapeSpecialChars(this.password)};${this.isSSIDHidden ? 'H:true' : ''};`;
  }

  @Watch('encryptionType')
  onEncryptionTypeChange(): void {
    this.noPassword = this.encryptionType === 'nopass';
  }

  saveCodeCallback(url: string) {
    this.qrCode = url;
  }

  // helper functions
  static escapeSpecialChars(str: string): string {
    return str.replace(/[;\\:,"]/g, '\\$&');
  }

  namedQRCodeSizeToNumber(): number {
    type sizeLookupTable = {
      [key: string]: number;
    };
    const lookupTable: sizeLookupTable = {
      small: 200,
      medium: 400,
      large: 600,
    };
    return lookupTable[this.qrCodeSizeSelected];
  }
}
